module.exports = __webpack_public_path__ + "static/media/twitter.0ecdf21a.svg";